{
  "View": "View",
  "fullProfile": "s full profile.",
  "ProfilePhrase1": "Meet thousands of people tinkering and promoting innovations on RebelBase.",
  "signUpFree": "Sign Up Free",
  "or": "or",
  "Login": "Login",
  "Projects": "Projects",
  "loading": "loading...",
  "NoProjects": "No projects.",
  "Boohoo": "Boohoo...You don't have a project yet!",
  "CreateProject": "Create a project",
  "Project": "Project",
  "CreateNewProject": "Create a new project",
  "save": "Save",
  "SocialLinks": "Social Links",
  "ProfilePhrase2": "Be social. Add your links so that others can connect.",
  "AddSocialLinks": "Add social links",
  "Connect": "Connect",
  "linkedinUsername": "linkedin username",
  "twitterHandle": "@twitterHandle",
  "facebookUsername": "facebook username",
  "About": "About",
  "ProfilePhrase3": "Looking pretty empty.",
  "NoAbout": "No About Yet",
  "ProfilePhrase4": "Tell your visitors a little about yourself. We recommend sharing your passions and specialities. If you're stuck, answer two of these questions: What is your mission in life? What do you care about? When do you work best? What in the past has prepared you for your goals?",
  "updatePic": "update pic",
  "ProfilePhrase5": "Experiences tell people what you've done and help others discover your projects.",
  "NoExperience": "No Experience Entries Yet",
  "JudgeBio": "Judge Bio for Events",
  "whoAreYou": "Who are you?",
  "EditBio": "Edit your bio",
  "NoJudgeBio": "No Judge Bio Yet",
  "Title": "Title",
  "JudgeBioPhrase": "Please tell the event attendees about yourself. We recommend sharing your recent accomplishments, your passions, and why you're the fairest in all the land.",
  "Delete": "Delete",
  "Experience": "Experience",
  "StartDate": "Start Date",
  "EndDate": "End Date",
  "Present": "Present",
  "ExperienceTitle": "Title of experience",
  "CompanyOrSchool": "Company or School",
  "AffiliatedCompanyOrSchool": "Affiliated company or school",
  "Description": "Description",
  "ShortDescription": "Short description of experience",
  "on": "On",
  "off": "Off",
  "PublicVisibility": "Public Visibility",
  "whoCanSee": "(Only you can see this)",
  "EditVisibility": "Edit Visibility",
  "NotLoggedinView": "Viewers who are not logged-in will see:",
  "ifOn": " you in search and your entire profile.",
  "ifOff": " only basic info (name, purpose, profile picture and projects you are attached to).",
  "Completed": "Completed",

  "Add": "Add",
  "Edit": "Edit"
}
